// Initialize the necessary sas and ltjs globals.
var global = globalThis;
global.sas = global.sas || {};
sas.ltjs = sas.ltjs || {};
sas.ltjslib = sas.ltjslib || {};
sas.ltjslib.ltjs = sas.ltjslib.ltjs || {};
export var ltjsGlobalNamespace = sas.ltjs;
export var ltjs = sas.ltjslib.ltjs;
